import { BLACK_a } from "baseStyles";
import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Container = styled.div`
  margin-top: 8rem;
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin-top: 4rem;
    flex-direction: column;
    text-align: center;
  }
`;

export const TextBox1 = styled.div`
  display: flex;
  flex-direction: column;
  width: 69.2rem;
  height: 41.8rem;

  & > div:nth-child(1) {
    font-weight: 700;
    font-size: 6.8rem;
    line-height: 10rem;
  }
  & > div:nth-child(2) {
    display: flex;
    flex-direction: column;
    margin-top: 3rem;
    font-weight: 300;
    font-size: 2rem;
    line-height: 3.6rem;
    color: ${BLACK_a};

    & > span:nth-child(2) {
      margin-top: 3.6rem;
    }
  }

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 100%;
    & > div:nth-child(1) {
      font-size: 3.6rem;
      line-height: 5.8rem;
    }
    & > div:nth-child(2) {
      margin-top: 1rem;
      font-size: 1.6rem;
      line-height: 2.8rem;
      & > span:nth-child(3) {
        margin-top: 2.8rem;
      }
    }
  }
`;
export const ImgBox1 = styled.div`
  & > img {
    width: 48.8rem;
    height: 48.8rem;
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    & > img {
      width: 30rem;
      height: 30rem;
    }
  }
`;
